import { cn, ia, io } from 'lib/helpers/utility';

import Filters from 'components/shared/Filters/Filters';
import FilterActions from 'components/shared/Filters/components/FilterActions';
import DisplayButtonAGTable from 'components/shared/AGTable/components/DisplayButtonAGTable/DisplayButtonAGTable';

import SearchInput from './SearchInput';

const TableFilters = ({
  filters,
  initialFilters,
  changeFilters,
  updateFilters,
  category,
  defaultFilters,
  isEditingFilter,
  className = '',
  disableActions = false,
  items = [],
  type,
  noDisplayButton = false,
  noFilterActions = false,
  modalView,
  hasData = true,
  itemsCount = 0
}) => {
  const hasActiveFilters = Object.values(filters || {}).some((v) => ia(v));
  const hasFiltersAndData = io(defaultFilters) && hasData;

  const lessThan10AndNoActive =
    io(defaultFilters) && itemsCount > 0 && itemsCount < 10 && !hasActiveFilters;
  const noFiltersAndNoData = !io(defaultFilters) && !hasData;

  const showFilters = hasFiltersAndData && !lessThan10AndNoActive && !noFiltersAndNoData;

  const showDisplayButton = !noDisplayButton;
  const showFilterActions = !noFilterActions && !!filters && hasFiltersAndData;

  if (!showFilters && !showDisplayButton && !showFilterActions) {
    return null;
  }

  return (
    <div
      className={cn(
        'outline-b flex min-h-10 items-start justify-between gap-2 bg-white px-4 py-2 outline-1 outline-offset-[-1px] outline-neutral-200',
        className
      )}>
      {showFilters ? (
        <div className="flex flex-wrap gap-2">
          <SearchInput
            defaultFilters={defaultFilters}
            filters={filters}
            changeFilters={changeFilters}
            updateFilters={updateFilters}
          />
          <Filters
            defaultFilters={defaultFilters}
            filters={filters}
            changeFilters={changeFilters}
            updateFilters={updateFilters}
          />
        </div>
      ) : (
        <div />
      )}
      <div className="flex flex-wrap items-start justify-end gap-2">
        {showDisplayButton && <DisplayButtonAGTable />}
        {showFilterActions && (
          <FilterActions
            filters={filters}
            initialFilters={initialFilters}
            changeFilters={changeFilters}
            category={category}
            isEditingFilter={isEditingFilter}
            disableActions={disableActions || modalView}
            items={items}
            type={type}
          />
        )}
      </div>
    </div>
  );
};

export default TableFilters;
